import { ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";
import { selectThemeMode } from "../app/slices/GlobalSlice";
import { createPiTheme } from "../theme";
import { useMemo } from "react";

interface PiThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Wrapper around MUI ThemeProvider that provides theme based on Redux theme state
 */
export default function PiThemeProvider({ children }: PiThemeProviderProps) {
  const themeMode = useSelector(selectThemeMode);
  const theme = useMemo(() => createPiTheme(themeMode), [themeMode]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
